import Vue from 'vue';
import Vuetify from 'vuetify';
import Vuelidate from 'vuelidate';
import Toasted from 'vue-toasted';
import {
  FormCheckboxPlugin, ModalPlugin, TooltipPlugin, ButtonPlugin, FormPlugin, DropdownPlugin,
  ProgressPlugin,
} from 'bootstrap-vue';
import App from './App.vue';

import router from './router/index';
import store from './store/index';
import filters from './filters';
import AppLoader from './components/shared/AppLoader.vue';

import 'babel-polyfill';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);
Vue.use(FormCheckboxPlugin);
Vue.use(ModalPlugin);
Vue.use(TooltipPlugin);
Vue.use(ButtonPlugin);
Vue.use(FormPlugin);
Vue.use(DropdownPlugin);
Vue.use(ProgressPlugin);
Vue.use(Vuelidate);
Vue.use(Toasted);

Vue.component('app-loader', AppLoader);

Vue.config.productionTip = false;

filters();

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app');
